module.exports = __webpack_public_path__ + "img/order-integration.c216f953.png";